<div class="position-relative">
    <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail position-absolute" style="top:12px; right:4px; line-height:0px" (click)="closePopup()">
        <svg class="icon-16"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
    </button>
    <cv-loader size="medium" [overlay]="true" *ngIf="processingAnswer || statusKnown"></cv-loader>
    <div style="height:374px" *ngIf="statusKnown"></div>
    <div *ngIf="ppas.isApproved && statusKnown">
        <div class="font-size-20 py-3 border-bottom mb-3" runat="server" langSection="Profile_Management" langKey="Profile_Picture_Change">Profile Picture Change</div>
        <div class="pb-4">
            <span class="lato-bold">{{ppas.loginName}}</span>
            <span runat="server" langSection="Profile_Management" langKey="Profile_Modal_Message">wants to change their profile picture. Do you approve this photo they chose?</span>
        </div>
        <div class="d-flex w-100 justify-content-center">
            <img [src]="imgLink" class="d-block" style="border-radius:50%">
        </div>
        <div class="d-flex py-3 border-top mt-4">
            <button type="button" class="btn btn-text pl-0" style="min-width:0px" (click)="closePopup()" runat="server" langSection="Common" langKey="Cancel_Button">Cancel</button>
            <div class="flex-grow-1"></div>
            <button type="button" class="btn btn-secondary mr-2" (click)="deny()" runat="server" langSection="Profile_Management" langKey="Deny">Deny</button>
            <button type="button" class="btn btn-primary" (click)="approve()" runat="server" langSection="Profile_Management" langKey="Approve">Approve</button>
        </div>
    </div>

    <div class="d-flex justify-content-center py-5" *ngIf="ppas.isApproved && statusKnown"
         runat="server" langSection="Profile_Management" langKey="Request_Expired">This user no longer has a pending profile picture change.</div>
</div>
